import { useA1EmbedNav } from "@/context/A1EmbedNavigationContext";
import navigationRoutes from "@/utils/navigationRoutes";
import { useMemo } from "react";

/**
 * In Service Desk admin embed, returns paths under `/sd/admin/...`;
 * otherwise same as `navigationRoutes`.
 */
export function useA1ResolvedNav() {
  const embed = useA1EmbedNav();
  return useMemo(() => {
    if (!embed) {
      return navigationRoutes;
    }
    return {
      ...navigationRoutes,
      SCHEMAS: embed.schemas,
      SCHEMA_ADD: embed.schemaAdd,
      SCHEMA_EDIT: (name: string) => embed.schemaEdit(name),
      SCHEMA_RENDER: (name: string) => embed.schemaRender(name),
      MODULE: (name: string) => embed.module(name),
      MODULE_ADD: (name: string) => embed.moduleAdd(name),
      MODULE_EDIT: (schemaName: string, id: string) =>
        embed.moduleEdit(schemaName, id),
      PRINT: (schemaName: string, recordId: string) =>
        embed.print(schemaName, recordId),
      IMPORTS: embed.imports,
      IMPORT_ADD: embed.importAdd,
      IMPORT_DETAIL: (id: string) => embed.importDetail(id),
      PERMISSIONS: embed.permissions,
      ROLES: embed.roles,
      ROLE_ADD: embed.roleAdd,
      ROLE_EDIT: (id: string) => embed.roleEdit(id),
      USERS: embed.users,
      USER_ADD: embed.userAdd,
      USER_EDIT: (id: string) => embed.userEdit(id),
      SLA_CONFIGURATION: embed.slaConfiguration,
      SLA_CONFIGURATION_ADD: embed.slaConfigurationAdd,
    };
  }, [embed]);
}
